import * as React from 'react'

import { Button } from '@/ui/button'
import { FaIcon, faEnvelope, faPrint, faXmark } from '@/lib/fa'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

type Props = {
  count: number
  pending?: boolean
  onGenerate: () => void
  onClear: () => void
  onSendEmail?: () => void
  generateLabel?: string
}

/**
 * Pasek akcji dla wielokrotnego wyboru raportow - pojawia sie po zaznaczeniu
 * przynajmniej jednego raportu na liscie.
 */
export const BatchGenerateBar: React.FC<Props> = ({
  count,
  pending,
  onGenerate,
  onClear,
  onSendEmail,
  generateLabel,
}) => {
  const { t } = useLocalize()

  if (count === 0) return null

  return (
    <div className="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-4 tw-border-t tw-border-secondary tw-bg-white tw-px-4 tw-py-3 tw-shadow-[0_-2px_6px_rgba(0,0,0,0.06)]">
      <div className="tw-flex tw-items-center tw-gap-3">
        <FaIcon icon={faPrint} className="tw-h-4 tw-w-4 tw-text-content-base" />
        <span className="tw-text-sm tw-font-medium tw-text-content-base">
          {t('printout.selected-reports-count').replace('{0}', String(count))}
        </span>
        <button
          type="button"
          onClick={onClear}
          className="tw-flex tw-items-center tw-gap-1 tw-text-xs tw-text-content-base/70 hover:tw-text-primary"
        >
          <FaIcon icon={faXmark} className="tw-h-3 tw-w-3" />
          {t('printout.clear-selection')}
        </button>
      </div>

      <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
        {onSendEmail && (
          <Button
            variant="primary"
            size="sm"
            onClick={onSendEmail}
            disabled={pending}
            className="tw-h-[38px] tw-rounded-lg tw-px-4 tw-text-sm tw-font-medium"
          >
            <FaIcon icon={faEnvelope} className="tw-mr-2 tw-h-4 tw-w-4" />
            {t('printout.send-selected')}
          </Button>
        )}
        <Button
          variant="primary"
          size="sm"
          onClick={onGenerate}
          disabled={pending}
          className="tw-h-[38px] tw-rounded-lg tw-px-4 tw-text-sm tw-font-medium"
        >
          {generateLabel ?? t('printout.generate-selected')}
        </Button>
      </div>
    </div>
  )
}

export default BatchGenerateBar
